import React from 'react';

const Impressum: React.FC = () => {
  return (
    <div className="page-container" style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={titleStyle}>Impressum</h1>
        
        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Angaben gemäß § 5 TMG</h2>
          <p style={textStyle}>
            <strong>VoyagePlanner GmbH</strong><br />
            Saseler Damm 43-45<br />
            22395 Hamburg<br />
            Deutschland
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Vertreten durch</h2>
          <p style={textStyle}>
            Geschäftsführer: Sven Mahn
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Registereintrag</h2>
          <p style={textStyle}>
            Eintragung im Handelsregister<br />
            Registergericht: Amtsgericht Hamburg<br />
            Registernummer: HRB 118354
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Kontakt</h2>
          <p style={textStyle}>
            <strong>Telefon:</strong> <a href="tel:+4940226348012" style={linkStyle}>040 226 348 012</a><br />
            <strong>E-Mail:</strong> <a href="mailto:kontakt@voyageplanner.app" style={linkStyle}>kontakt@voyageplanner.app</a>
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Umsatzsteuer-ID</h2>
          <p style={textStyle}>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            <em>(Wird bei Bedarf ergänzt)</em>
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p style={textStyle}>
            Sven Mahn<br />
            Saseler Damm 43-45<br />
            22395 Hamburg
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>EU-Streitschlichtung</h2>
          <p style={textStyle}>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={linkStyle}>
              https://ec.europa.eu/consumers/odr/
            </a>
            <br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p style={textStyle}>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Haftung für Inhalte</h2>
          <p style={textStyle}>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
            zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p style={textStyle}>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
            der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Haftung für Links</h2>
          <p style={textStyle}>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die 
            verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          </p>
          <p style={textStyle}>
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte 
            einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige 
            Links umgehend entfernen.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Urheberrecht</h2>
          <p style={textStyle}>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. 
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p style={textStyle}>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter 
            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine 
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden 
            von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
        </section>
      </div>
    </div>
  );
};

// Styles
const containerStyle: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#f8f9fa',
  padding: '2rem 1rem',
};

const contentStyle: React.CSSProperties = {
  maxWidth: '900px',
  margin: '0 auto',
  backgroundColor: 'white',
  padding: '3rem',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
};

const titleStyle: React.CSSProperties = {
  fontSize: '2.5rem',
  fontWeight: '700',
  color: '#2c3e50',
  marginBottom: '2rem',
  borderBottom: '3px solid #3498db',
  paddingBottom: '1rem',
};

const sectionStyle: React.CSSProperties = {
  marginBottom: '2rem',
};

const sectionTitleStyle: React.CSSProperties = {
  fontSize: '1.5rem',
  fontWeight: '600',
  color: '#34495e',
  marginBottom: '1rem',
};

const textStyle: React.CSSProperties = {
  fontSize: '1rem',
  lineHeight: '1.8',
  color: '#555',
  marginBottom: '1rem',
};

const linkStyle: React.CSSProperties = {
  color: '#3498db',
  textDecoration: 'none',
  fontWeight: '500',
};

export default Impressum;

